module.exports = __webpack_public_path__ + "static/media/16.399d4d8d.jpg";